import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../data.service';
import { OTPChallengeResponse } from '../models/otpChallengeResponse';
import { OTPValidationRequest } from '../models/otpValidationRequest';
import { ClaimElevationRequest } from '../models/claimElevationRequest';
import { LoginResponseModel } from '../models/loginResponseModel';
import { Location } from '@angular/common';
import { CardBearerModel } from '../models/cardBearerModel';

@Component({
  selector: 'app-otpprompt',
  templateUrl: './otpprompt.component.html',
  styleUrls: ['./otpprompt.component.scss']
})
export class OtppromptComponent implements OnInit {

  constructor(private data : DataService, private router: Router, private location:Location) { }

  public req : OTPValidationRequest = new OTPValidationRequest();

  public errMessage : string = "";

  ngOnInit(): void {
    this.promptOTP();
  }

  promptOTP() : void {
    this.data.request<OTPChallengeResponse>("auth/otp/self",null,"GET").subscribe((v) => {
      this.req.id = v.ChallengeID;
    })
  }

  onOtpSubmit() : void {
    //Validate the data first
    if (!this.validate()){
      return;
    }

    this.data.request<string>("auth/otp/validate",this.req,"POST").subscribe((v) => {
      this.elevateToken();
    },
    (error) => {
      this.errMessage = "Failed to validate the OTP, please try again."
    });
  }

  validate() : boolean {
    if (!new RegExp('^[0-9]{6}$').test(this.req.password)){
      this.errMessage = "6 digit pin is required";
      return false;
    } else {
      return true;
    }
  }

  elevateToken() {
    var r: ClaimElevationRequest= new ClaimElevationRequest();
    r.ChallengeKey = this.req.id;
    this.data.request<LoginResponseModel>("auth/refresh_token",this.req,"POST").subscribe((v) => {
      this.data.token = v.token;
      this.data.isLoggedIn = true;


      this.data.RaiseEvent("login");
      this.router.navigate(['loadingprogress'],{skipLocationChange:true});
    },
    (error) => {
      this.errMessage = "Failed to validate the OTP, please try again."
    });
  }
  
  onRetry() : void{
    this.router.navigate([''],{skipLocationChange:true});
  }

}
